module.exports = __webpack_public_path__ + "img/commodities.b23581cb.svg";